import React from 'react'
import { Flex, Box } from 'grid-styled'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import {
  renderSelectField,
  renderAgencyInput,
  renderAccountInput,
  renderAccountDigitInput
} from '../../../utils/renderInputs'
import { required } from '../../../utils/validators'
import { labels } from './data.json'

const DebitPaymentForm = ({ banks, blockFields }) => (
  <div>
    <Box mb={[24, 28]} width={[1, 380]}>
      <Field
        component={renderSelectField}
        label={labels.bank}
        placeholder={labels.placeholder.bank}
        name="bankCode"
        options={banks}
        validate={required}
        disabled={blockFields}
      />
    </Box>
    <Flex direction={['column', 'row']} width={[1, 380]}>
      <Box mb={[17, 20]} mr={33} width={1}>
        <Field
          component={renderAgencyInput}
          label={labels.agency}
          name="agency"
          placeholder={labels.placeholder.agency}
          validate={required}
        />
      </Box>
      <Box mb={[17, 20]} mr={33} width={1}>
        <Field
          component={renderAccountInput}
          label={labels.account}
          name="account"
          placeholder={labels.placeholder.account}
          validate={required}
        />
      </Box>
      <Box mb={[17, 20]} width={1}>
        <Field
          component={renderAccountDigitInput}
          label={labels.accountDigit}
          name="accountDigit"
          placeholder={labels.placeholder.accountDigit}
          validate={required}
          limitDigit={1}
        />
      </Box>
    </Flex>
  </div>
)

const mapStateToProps = ({ reducer }) => ({
  banks: reducer.banks
})

export default connect(mapStateToProps, null)(DebitPaymentForm)



// WEBPACK FOOTER //
// ./src/app/modules/PaymentForm/debit.js